<div id="overlay-spinner">
    <div *ngIf="loading" class="row" id="page-level-loader">
        <div id="loaderOverlaySkin" class="modal-backdrop fade in" aria-hidden="true"></div>
        <span class="col-md-12 customspinner">
            <em class="icon-spinner" role="img" [attr.aria-label]="'Please wait image'"></em>
        </span>
    </div>
</div>